import { List as RaList, ListView } from 'react-admin'
import { ExtraCreateButton } from './ExtraCreateButton'
import { ListActions } from './ListActions'

export const List = (props) => {
  const { filter = {}, perPage = 10, ...rest } = props
  return (
    <RaList
      {...rest}
      filter={filter}
      perPage={perPage}
      actions={
        props.actions === null
          ? null
          : props.actions || <ListActions searchBarPlaceholder={props.searchBarPlaceholder} />
      }
      extraCreateButton={
        props.extraCreateButton || (
          <ExtraCreateButton
            extraCreateButton={props.extraCreateButton}
            extraCreateButtonLabel={props.extraCreateButtonLabel}
            basePath={props.basePath}
            resource={props.resource}
          />
        )
      }
    />
  )
}

List.propTypes = {
  ...RaList.propTypes,
  ...ListView.propTypes,
}

export default List
